'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTransitionGroup = require('react-transition-group');

var _portal = require('./portal');

var _portal2 = _interopRequireDefault(_portal);

var _utils = require('./utils');

var _style = require('./style');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PopPop = function (_Component) {
  _inherits(PopPop, _Component);

  function PopPop(props) {
    _classCallCheck(this, PopPop);

    var _this = _possibleConstructorReturn(this, (PopPop.__proto__ || Object.getPrototypeOf(PopPop)).call(this, props));

    _this.handleOverlayClick = function () {
      if (_this.props.onClose && _this.props.closeOnOverlay) {
        _this.props.onClose();
      }
    };

    _this.handleCloseBtn = function () {
      if (_this.props.onClose) {
        _this.props.onClose();
      }
    };

    _this.handleEscKeyDown = function (e) {
      if (_this.props.onClose && _this.props.closeOnEsc && e.keyCode === 27) {
        _this.props.onClose();
      }
    };

    return _this;
  }

  _createClass(PopPop, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.closeOnEsc) {
        document.addEventListener('keydown', this.handleEscKeyDown);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.closeOnEsc) {
        document.removeEventListener('keydown', this.handleEscKeyDown);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          open = _props.open,
          position = _props.position,
          overlayStyle = _props.overlayStyle,
          contentStyle = _props.contentStyle;

      var extractPosition = (0, _utils.extractCamelCase)(position);
      var mergeWrapperStyle = _extends({}, _style2.default.wrapper, _style2.default.alignItems[extractPosition[0]], _style2.default.justifyContent[extractPosition[1]]);

      var mergeOverlayStyle = _extends({}, _style2.default.overlay, overlayStyle);

      var mergeContentStyle = _extends({}, _style2.default.content, contentStyle);

      if (!open) return null;

      return _react2.default.createElement(
        _portal2.default,
        null,
        _react2.default.createElement(
          _reactTransitionGroup.Transition,
          { 'in': open, appear: true, timeout: 0 },
          function (state) {
            return _react2.default.createElement(
              'div',
              { style: _extends({}, mergeWrapperStyle, _style2.default.transitionStyles[state]) },
              _react2.default.createElement('div', { onClick: _this2.handleOverlayClick,
                style: mergeOverlayStyle }),
              _react2.default.createElement(
                'div',
                { style: mergeContentStyle },
                _this2._renderCloseBtn(),
                _this2.props.children
              )
            );
          }
        )
      );
    }
  }, {
    key: '_renderCloseBtn',
    value: function _renderCloseBtn() {
      if (this.props.closeBtn) {
        return _react2.default.createElement(
          'div',
          { style: _style2.default.closeBtn, onClick: this.handleCloseBtn },
          _react2.default.createElement(
            'svg',
            { viewBox: '0 0 40 40' },
            _react2.default.createElement(
              'g',
              null,
              _react2.default.createElement('path', { d: 'm31.6 10.7l-9.3 9.3 9.3 9.3-2.3 2.3-9.3-9.3-9.3 9.3-2.3-2.3 9.3-9.3-9.3-9.3 2.3-2.3 9.3 9.3 9.3-9.3z' })
            )
          )
        );
      }
      return null;
    }
  }]);

  return PopPop;
}(_react.Component);

PopPop.defaultProps = {
  position: 'topCenter',
  closeOnOverlay: true,
  overlayStyle: {}
};
exports.default = PopPop;
module.exports = exports['default'];